export default __webpack_public_path__ + "static/media/Cycling Instructor Course.dabd0799.pdf";